import React from "react"
import ReactDOM from "react-dom/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

// Self-hosted fonts (bundled into the build — no CDN, works in locked-down
// browsers and inside the ADO iframe).
import "@fontsource-variable/bricolage-grotesque"
import "@fontsource-variable/hanken-grotesk"
import "@fontsource/ibm-plex-mono/400.css"
import "@fontsource/ibm-plex-mono/500.css"
import "@fontsource/ibm-plex-mono/600.css"

import App from "./App"
import { SiteGate } from "@/components/SiteGate"
import "./index.css"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat as fresh for 60s after each fetch — avoids hammering during nav.
      staleTime: 60_000,
      // Don't retry forever on transient failures.
      retry: 3,
      refetchOnWindowFocus: true,
    },
  },
})

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SiteGate>
        <App />
      </SiteGate>
    </QueryClientProvider>
  </React.StrictMode>,
)
